import SpecificationCard from './SpecificationCard';
export default SpecificationCard;
